import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ACADEMIC_TITLE_NONE } from "@constants";

export const useProfileSelectOptions = () => {
  const { t } = useTranslation();

  return useMemo(() => {
    const genderOptions: Record<string, string> = {
      male: t("settings.profile.form.genderOption.male"),
      female: t("settings.profile.form.genderOption.female"),
    };

    const academicTitleOptions: Record<string, string> = {
      [ACADEMIC_TITLE_NONE]: t(
        "settings.profile.form.academicTitleOption.none"
      ),
      "Dr.": t("settings.profile.form.academicTitleOption.dr"),
      "Prof.": t("settings.profile.form.academicTitleOption.prof"),
      "Prof. Dr.": t("settings.profile.form.academicTitleOption.profDr"),
    };

    const formatAcademicTitle = (value: string | undefined): string => {
      if (value == null || value === "") return "";
      return academicTitleOptions[value] ?? value;
    };

    return {
      genderOptions,
      academicTitleOptions,
      formatAcademicTitle,
    };
  }, [t]);
};
